export default __webpack_public_path__ + "static/video-744f1bf7bd0ea9cf31a60d8b076669cf.mp4";